import './melgroupleonda4/style';
import FormStructure from './melgroupleonda4/form_structure';

export default FormStructure;